import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

export interface DataLayerEvent {
  event: string;
  eventCategory: string;
  eventAction: string;
  eventLabel?: string;
}

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticalService {

  constructor(
    private gtmService: GoogleTagManagerService,
  ) {
  }

  getDataLayer() {
    return this.gtmService.getDataLayer();
  }

  public pushTag(gtmTag) {
    if (environment.enableGTAGID) {
      this.gtmService.pushTag(gtmTag).catch((error) => {
        console.log('Gtm service promise breaking with error: ', error);
      });
    }
  }

  pushGAEvent(event: string, eventCategory: string, eventAction: string, financeType?: string, productDesc?: string): void {
    const gAEvent: DataLayerEvent = {
      event,
      eventCategory,
      eventAction
    };
    if (financeType && productDesc) {
      gAEvent.eventLabel = `${financeType}: ${productDesc}`;
    }
    this.pushTag(gAEvent);
  }
}

